import 'angular';

/**
 * @ngdoc overview
 * @name Angular utility functions
 *
 * @description
 * Constants and configurations for the GorillaBoy web application (top-level).
 */
angular.module('GorillaBoy.common')
.run(['$rootScope', '$log', function($rootScope, $log) {
    
    /**
     * Registers a callback function which will be called after the current digest finishes.
     * Any changes made to the "view models" i.e., $scopes in this callback will be ignored until the next $digest()
     *
     * This method is primarily useful to capture post digest() metrics viz. render latencies etc.,
     */   
    $rootScope.registerPostDigestCallback = function(callbackFn) {
        $rootScope.$$postDigest(function registerPostDigestCallbackAnonymous() {
            try {
                callbackFn();
            } catch (e) {
                $log.error("Error occured while executing $$postDigest()", e);
            }
        });
    };        

}]);
